import React, { Component } from "react";
import * as vars from "../../constants/constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SimpleBar from "simplebar";
import { console_log } from "../../utils/helper";
import { config } from "../../constants/domainConfig";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { changeLangAction } from "../../actions/WelcomeActions";
import {
  isAfricatv,
  isMobio360Plus,
  isMobioplus,
} from "../../constants/multiDomains";
import { showCuCa } from "../../constants/showCuCa";
import { onUnsubClick } from '../../utils/unsubHelper';

const zaDomain = config.domain == "za" ? true : false;
const ptDomain = config.domain == "pt" ? true : false;
const bizaoDomain =
  config.domain == "ci" ||
  config.domain == "cd" ||
  config.domain == "cm" ||
  config.domain == "tn" ||
  config.domain == "sn"
    ? true
    : false;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openNotification: false,
      openLanguage: false,
    };

    this.hideSideBar = this.hideSideBar.bind(this);
  }

  handleClick(name, e) {
    e.preventDefault();
    switch (name) {
      case "notification": {
        this.setState({
          openNotification: !this.state.openNotification,
        });
        break;
      }
      case "language": {
        this.setState({
          openLanguage: !this.state.openLanguage,
          openNotification: false,
        });
        break;
      }
    }
  }

  componentWillMount() {}

  componentDidMount() {
    var el = new SimpleBar(document.getElementById("sidebar"), {
      autoHide: true,
    });
    el.recalculate();
    el.getScrollElement();
    SimpleBar.removeObserver();
  }

  hideSideBar() {
    document.body.classList.toggle("sidebar-hidden");
    document.body.classList.toggle("sidebar-mobile-show");
  }
  handleChange(event) {
    this.props.changeLang(event);

    this.props.changeLangAction({
      currentLang: event,
    });

    this.setState({});
  }
  render() {
    const handleClick = this.handleClick;
    const isAdmin = this.props.isAdmin;
    let classNameLang = this.state.openLanguage
      ? "navigate-item navigate-dropdown open"
      : "navigate-item navigate-dropdown";
    classNameLang =
      this.props.currentLang == "ar" ? classNameLang + " ar" : classNameLang;
    let classNameli = "navigate-item";
    classNameli =
      this.props.currentLang == "ar" ? classNameli + " ar" : classNameli;
    const uid = this.props.access.uid;
    const ppLinkBizao = {
      ci: "http://n.mobi360vr.com/ci/tnc-mobio360?offer=1&_next=privacy_policy.html",
      cd: "http://n.mobi360vr.com/cd/tnc-mobio360?offer=1&_next=privacy_policy.html",
      cm: "http://n.mobi360vr.com/cm/tnc-mobio360?offer=1&_next=privacy_policy.html",
      tn: "http://n.mobi360vr.com/tn/tnc-mobio360?offer=1&operator=TN_ORANGE&operatorSubmitted=Y&_next=privacy_policy.html",
      sn: "http://n.mobi360vr.com/sn/tnc-mobio360?offer=1&_next=privacy_policy.html",
    };
    const tncLinkBizao = {
      ci: "http://n.mobi360vr.com/ci/tnc-mobio360?offer=1&_next=general_conditions.html",
      cd: "http://n.mobi360vr.com/cd/tnc-mobio360?offer=1&_next=general_conditions.html",
      cm: "http://n.mobi360vr.com/cm/tnc-mobio360?offer=1&_next=general_conditions.html",
      tn: "http://n.mobi360vr.com/tn/tnc-mobio360?offer=1&operator=TN_ORANGE&operatorSubmitted=Y&_next=general_conditions.html",
      sn: "http://n.mobi360vr.com/sn/tnc-mobio360?offer=1&_next=general_conditions.html",
      pt: "http://n.mobi360vr.com/pt/tnc-mobio360?offer=1&device=pc&_next=general_conditions.html",
    };
    return (
      <div id="sidebar" className="sidebar">
        <a href="/#/account" onClick={this.hideSideBar}>
          <div className="profile">
            <img
              className="profile__image"
              alt="Avatar"
              src={
                this.props.account.user.profilePic
                  ? this.props.account.user.profilePic
                  : "./img/avatar.png"
              }
            />
            <p className="profile__name">{this.props.account.user.name}</p>
          </div>
        </a>
        <nav className="sidebar-navigate">
          {isAdmin ? (
            <ul className="list-unstyled navigate">
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/category/vod/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home"></i>
                  <span>
                    <FormattedMessage id="home" defaultMessage="Home" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/domain/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-cogs"></i>
                  <span>
                    <FormattedMessage id="domain" defaultMessage="Domain" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/country/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-globe"></i>
                  <span>
                    <FormattedMessage id="country" defaultMessage="Country" />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/manage-categories/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-filter"></i>
                  <span>
                    <FormattedMessage
                      id="manageCategories"
                      defaultMessage="Manage Categories"
                    />
                  </span>
                </a>
              </li>
            </ul>
          ) : (
            <ul className="list-unstyled navigate">
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/category/vod/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-home" aria-hidden="true"></i>
                  <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                    <FormattedMessage id="home" defaultMessage="Home" />
                  </span>
                </a>
              </li>
              {!isMobioplus() ? (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={`/#/account/?uid=${uid}`}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-user-circle" aria-hidden="true"></i>
                    <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                      <FormattedMessage
                        id="myAcc"
                        defaultMessage="My Account"
                      />
                    </span>
                  </a>
                </li>
              ) : (
                ""
              )}
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/favorites/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-heart"></i>
                  <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                    <FormattedMessage
                      id="favorites"
                      defaultMessage="Favorites"
                    />
                  </span>
                </a>
              </li>

              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/category/vod/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <i className="fa fa-video-camera" aria-hidden="true"></i>
                  <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                    <FormattedMessage
                      id="360Vids"
                      defaultMessage="360 Videos"
                    />
                  </span>
                </a>
              </li>
              <li className="navigate-item">
                <a
                  className="navigate-link"
                  href={`/#/history/?uid=${uid}`}
                  onClick={this.hideSideBar}
                >
                  <img
                    className="history-sidebar-icon"
                    src="./img/history.svg"
                    alt="history"
                  />
                  <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                    <FormattedMessage id="history" defaultMessage="History" />
                  </span>
                </a>
              </li>
              {showCuCa(config.domain) && (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={
                      isMobio360Plus()
                        ? `https://mobio360plus.com/customer-care?subdomain=${config.domain}`
                        : `https://mobio360.com/customer-care?subdomain=${config.domain}`
                    }
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-question" aria-hidden="true"></i>
                    <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                      <FormattedMessage id="help" defaultMessage="Contact Us" />
                    </span>
                  </a>
                </li>
              )}
              {!isMobio360Plus() ? (
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    href={`/#/panoramic/?uid=${uid}`}
                    onClick={this.hideSideBar}
                  >
                    <i className="fa fa-image" ria-hidden="true"></i>
                    <span className={config.dir == "rtl" ? "sidebar-ar" : ""}>
                      <FormattedMessage
                        id="panoramic-360"
                        defaultMessage="Panoramic 360"
                      />
                    </span>
                  </a>
                </li>
              ) : null}
              {config.domain === "th" ? (
                <li className="navigate-item">
                  <a className="navigate-link" href="" onClick={onUnsubClick}>
                    <i className="fa fa-user-times" ria-hidden="true"></i>
                    <span className="">
                      <FormattedMessage id="unsub" defaultMessage="UNSUBSCRIBE" />
                    </span>
                  </a>
                </li>
              ) : null}
              {isAfricatv() ||
                (config.country === "pl" && (
                  <li className="navigate-item">
                    <a className="navigate-link" href="/#/terms-conditions">
                      <span>
                        <i className="fa fa-lock"></i>
                        <FormattedHTMLMessage
                          id="tnc"
                          defaultMessage="Terms &amp; Conditions"
                        />
                      </span>
                    </a>
                  </li>
                ))}
              {isAfricatv() && (
                <div className="unsub_africa">
                  <h2>
                    <FormattedMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </h2>
                  <p>Dial *135*997# or call 0861131009</p>
                </div>
              )}
              {/* {(config.domain==='demo')?
                            <li className='navigate-item'>
                            <a className='navigate-link' href={`/#/ContactUs/?uid=${uid}`} onClick={this.hideSideBar}>
                                <img className="history-sidebar-icon" src="./img/history.svg" alt="history" />
                                <span className={config.dir=='rtl' ? 'sidebar-ar' : ''}>
                                    <FormattedMessage id="Conatact Us"
                                        defaultMessage="Contact Us"
                                    />
                                </span>
                            </a>
                        </li>
                        :null} */}
              {config.dir == "rtl" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span
                      className={
                        config.lang == "ar" ? "children sidebar-ar" : "children"
                      }
                    >
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul
                    className={
                      config.lang == "ar"
                        ? "navigate-dropdown-items sidebar-ar"
                        : "navigate-dropdown-items"
                    }
                  >
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("ar")}
                      >
                        <span
                          style={
                            config.lang === "ar"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.ar"
                            defaultMessage="ar"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          style={
                            config.lang === "en"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="en"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.domain == "be" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("be")}
                      >
                        <span
                          style={
                            config.lang === "be"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.be"
                            defaultMessage="Dutch"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          style={
                            config.lang === "fr"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          style={
                            config.lang === "de"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.domain == "ch" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          style={
                            config.lang === "de"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          style={
                            config.lang === "fr"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("it")}
                      >
                        <span
                          style={
                            config.lang === "it"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.it"
                            defaultMessage="Italian"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          style={
                            config.lang === "en"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
              {config.domain == "lu" ? (
                <li className={classNameLang}>
                  <a
                    className="navigate-link navigate-dropdown-toggle"
                    onClick={handleClick.bind(this, "language")}
                  >
                    <i className="fa fa-language"></i>
                    <span className="children">
                      <div className="langdropdown">
                        <FormattedMessage
                          id="sidebar.lang"
                          defaultMessage="Languages"
                        />
                        <i className="expand"></i>
                      </div>
                    </span>
                  </a>
                  <ul className="navigate-dropdown-items">
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("fr")}
                      >
                        <span
                          style={
                            config.lang === "fr"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.fr"
                            defaultMessage="French"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("en")}
                      >
                        <span
                          style={
                            config.lang === "en"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.en"
                            defaultMessage="English"
                          />
                        </span>
                      </a>
                    </li>
                    <li className={classNameli}>
                      <a
                        className="navigate-link"
                        onClick={() => this.handleChange("de")}
                      >
                        <span
                          style={
                            config.lang === "de"
                              ? {
                                  textDecoration: "underline",
                                  marginTop: "11px",
                                }
                              : { marginTop: "11px" }
                          }
                        >
                          <FormattedMessage
                            id="sidebar.lang.de"
                            defaultMessage="German"
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </li>
              ) : null}
            </ul>
          )}
          {bizaoDomain ? (
            <div>
              <li className="divider"></li>
              <ul className="list-unstyled navigate">
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    onClick={(e) => {
                      window.location = ppLinkBizao[config.domain];
                    }}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedMessage
                        id="privacyPolicy"
                        defaultMessage="Privacy Policy"
                      />
                    </span>
                  </a>
                </li>
                <li className="navigate-item">
                  <a
                    className="navigate-link"
                    onClick={(e) => {
                      window.location = tncLinkBizao[config.domain];
                    }}
                  >
                    <i className="fa fa-lock"></i>
                    <span>
                      <FormattedHTMLMessage
                        id="tnc"
                        defaultMessage="Terms &amp; Conditions"
                      />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          ) : null}
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLangAction,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js